// src/components/productDetail/StatsBlock.tsx
import React from 'react';
import { Package, BookOpen, Clock, Target } from 'lucide-react';
import './StatsBlock.css';

interface StatItem {
    label: string;
    value: string | number;
    icon?: string;
}

interface StatsBlockProps {
    items: StatItem[];
}

const iconMap: Record<string, React.ReactNode> = {
    'package': <Package size={24} />,
    'book': <BookOpen size={24} />,
    'clock': <Clock size={24} />,
    'target': <Target size={24} />
};

export const StatsBlock: React.FC<StatsBlockProps> = ({ items }) => {
    return (
        <div className="prdth-stats-block">
            <div className="prdth-stats-grid">
                {items.map((item, index) => (
                    <div key={index} className="prdth-stat-item">
                        {item.icon && (
                            <div className="prdth-stat-icon">
                                {iconMap[item.icon] || <Target size={24} />}
                            </div>
                        )}
                        <div className="prdth-stat-content">
                            <div className="prdth-stat-value">{item.value}</div>
                            <div className="prdth-stat-label">{item.label}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};